import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../..';
import { ProgressState, progressAdapter } from './progressSlicer';

export const {
    selectAll: selectAllDownloads,
    selectById: selectByDownloadId,
    selectTotal: selectTotalDownloads
} = progressAdapter.getSelectors<RootState>(state => state.downloads);

export const selectTotalProgress = createSelector(selectAllDownloads, state => {
    const totalProgress = state.reduce((sum, current) => (sum += current.progress ?? 0), 0);
    return {
        progress: state.length > 0 ? Math.round(totalProgress / state.length) : 0,
        all: state.length,
        done: state.filter(x => x.state === ProgressState.DONE).length
    };
});
